// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f8d18f39","497":"b989ea9b","977":"ea4bbcf1"}[chunkId] + ".chunk.js";
};